import { render, staticRenderFns } from "./report-photo.vue?vue&type=template&id=3d3ed1bf&scoped=true"
import script from "./report-photo.vue?vue&type=script&setup=true&lang=js"
export * from "./report-photo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./report-photo.vue?vue&type=style&index=0&id=3d3ed1bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3ed1bf",
  null
  
)

export default component.exports